import { Box, Image, Text } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'

const Caption = styled(Text)`
  white-space: pre-wrap;
`

const Picture = styled(Image)`
  margin: auto;
  border-radius: 100%;
  object-fit: cover;
`

const Value = ({ imageSrc, imageAlt, headLine }) => {
  return (
    <Box m='auto' width={[1, null, 1 / 3]} px={[3, null, null, null, 4, 3]} mt={[4, null, 0]}>
      <Picture src={imageSrc} alt={imageAlt} width='160px' height='160px' />
      <Caption color='text.light' fontSize={3} textAlign='center' mt={3}>
        {headLine}
      </Caption>
    </Box>
  )
}

export default Value
